<template>
  <b-card title="Несопоставленные считывания">
    <div v-if="!readings || readings.length === 0" class="text-muted">
      Все считывания сопоставлены с участниками ✅
    </div>

    <div v-else>
      <b-alert variant="warning" show>
        <strong>Найдено {{ readings.length }} несопоставленных считываний</strong>
        <p class="mb-0 mt-2 small">
          Эти считывания не связаны ни с одним участником. 
          Возможно нужно добавить участника или проверить chip ID.
        </p>
      </b-alert>

      <b-table
        :items="readings"
        :fields="fields"
        small
        striped
        responsive
      >
        <template #cell(code)="data">
          <code>{{ data.value }}</code>
        </template>

        <template #cell(actions)="data">
          <b-button
            size="sm"
            variant="outline-primary"
            @click="$emit('assign-reading', data.item)"
          >
            Назначить участнику
          </b-button>
        </template>
      </b-table>
    </div>
  </b-card>
</template>

<script>
import { BCard, BAlert, BTable, BButton } from 'bootstrap-vue'

export default {
  name: 'UnmatchedReadings',
  components: {
    BCard,
    BAlert,
    BTable,
    BButton,
  },
  props: {
    readings: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fields: [
        { key: 'code', label: 'Код чипа' },
        { key: 'num', label: 'Номер' },
        { key: 'actions', label: 'Действия' },
      ],
    }
  },
}
</script>

<style scoped>
code {
  background: #f8f8f8;
  padding: 0.286rem 0.571rem;
  border-radius: 0.358rem;
  font-family: 'Montserrat', 'Courier New', monospace;
  color: #5e5873;
  border: 1px solid #ebe9f1;
  font-size: 0.857rem;
  font-weight: 500;
}
</style>

